<template>
    <div class="futureCityDescriptionContent">
      <div class="topImgContent">
        <div class="topImgTitleContent">
          <div class="topImgTitle">服开区重点园区</div>
          <div class="topImgsubTitle">FUTURE SCIENCE CITY NEWS</div>
        </div>
      </div>
      <div class="fcd_blockContent1 e-flex">
        <div class="fcd_planRangeLeft1">
          <div class="fcd_blockTitle">一、重点园区规划</div>
          <div class="fcd_blockCommon">
            <p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;能源谷核心区东至京承高速路、南至七北南路、西至北七家镇中心组团东边界、北至顺于路西延，规划总占地面积10平方公里，规划总建筑规模724万平方米，已建成385万平方米、在建164万平方米、待建175万平方米。</p>
            <p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;2023年重点园区现有企业1261家，外资企业40家，科技服务业企业668家，国家高新技术企业92家，年度实现税收收入29.57亿元。</p></div>
        </div>
        <img class="fcd_blockImg1_1" src="@/assets/images/parkDescription/block2_1.png">
      </div>
      <div class="fcd_blockContent4 e-flex" style="margin-top: 0;">
        <img class="fcd_blockImg4_1" src="@/assets/images/parkDescription/block2_2.png">
        <div class="fcd_planRangeLeft4_1">
            <div class="fcd_blockTitle">二、服务业开放政策</div>
          <div class="fcd_blockCommon">
            <p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;围绕电信服务、健康医疗服务、金融服务、文化教育、专业服务、数字经济国际规则等六个方面，提出170多项任务举措。</p>
            <p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;其中，数字经济针对《全面与进步跨太平洋伙伴关系协定》（CPTPP）和《数字经济伙伴关系协定》（DEPA）开展先行先试，提出相关对接举措约70项，占整个试点任务的40%。健康医疗服务领域推动约15项国际交流与合作措施。金融机构开展市场化合作近20项优化金融服务模式和管理手段。完善公共服务政策环境约15项措施推进建设创新成果转化运用体系。</p></div>
        </div>
      </div>
      <div class="fcd_blockContent2 e-flex">
        <div class="fcd_blockContent2Center">
          <div class="fcd_blockTitle">三、创新资源</div>
          <div class="fcd_blockCommon">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;能源谷既有国家电网、南方电网“两张网”，中国石化、中国石油、中国海油“三桶油”以及国家能源、国家电投、中国华能、中国大唐、中国华电等“五大发电集团”能源央企设立的研究院，也有三一重能、海卓动力、西清能源等民营高科技企业，覆盖了电力、石油、新能源等领域，形成了研发、生产、服务、销售等较为完善的产业链条，是北京能源企业的主要聚集区。累计建成国家和市级重点实验室、工程技术中心46个，设有院士工作站7个，入驻了2万余名科研人才。</div>
        </div>
      </div>
      <div class="e-flex" style="justify-content: center;">
        <img class="fcd_blockContent2Img2" src="@/assets/images/parkDescription/block2_3.png">
      </div>
      <div class="fcd_blockContent5 e-flex">
        <div class="fcd_planRangeLeft5_1">
            <div class="fcd_blockTitle">四、成果转化</div>
          <div class="fcd_blockCommon">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;能源谷紧盯成果就地转化，举办技术成果推介大会，搭建技术成果交流平台，过去三年20家研究院（科技公司）78项成果在“能源谷”就地转化。持续做强国网、国电投2个大中小企业融通发展平台，累计入驻创新主体113家，其中专精特新企业11家，国家级高新技术企业25家；华北电力大学双碳技术转移转化中心依托储能示范区发展，招引培育华大高科等一批优质项目；培育壮大碳力加速器等4个民营孵化器，已注册落地各类企业37家。</div>
        </div>
        <img class="fcd_blockImg5_1" src="@/assets/images/parkDescription/block2_4.png">
      </div>
      <div class="fcd_blockContent4 e-flex">
        <img class="fcd_blockImg6_1" src="@/assets/images/parkDescription/block2_5.png">
        <div class="fcd_planRangeLeft6_1">
            <div class="fcd_blockTitle">五、产业聚集</div>
            <div class="fcd_blockCommon">
                <p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;先进能源产业是我区第一大产业，为北京打造万亿级绿色智慧能源产业集群。我们制定了先进能源产业提质增效行动计划，制定了能源互联网、氢能等一批政策。</p>
                <p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;“能源谷”核心区商务配套规划总建筑面积约180万平方米、商业配套约19万平方米。能源谷核心区周边44.3平方公里进行统筹规划，集中布局了研发中试、商务办公、成果转化业空间，为产业发展提供空间载体。</p></div>
            </div>
      </div>
      <div class="fcd_blockContent2 e-flex">
        <div class="fcd_blockContent2Center1 fcd_blockContent2Center1_1">
          <div class="fcd_blockTitle">六、创新成果</div>
          <div class="fcd_blockCommon">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;2个入驻央企主导项目获评央企10大国之重器，华能清能院碳捕集领域专利获中国专利金奖。截至目前，入驻企业累计承担能源工业互联网、智能电网、大飞机等50余项国家重大专项（其中国家重点研发计划33项），创制国家、国际标准416项，获评有效专利13134件。</div>
        </div>
      </div>
      <div class="fcd_blockContent2 e-flex">
        <div class="fcd_blockContent2Center1 fcd_blockContent2Center1_2">
          <div class="fcd_blockTitle">七、创新案例</div>
          <div class="fcd_blockCommon">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;大小融通、二期、国际标准ISO 37115《城市和社区可持续发展-零碳城市实现路径的实用案例》</div>
        </div>
      </div>
      <div class="fcd_blockContent2 e-flex">
        <div class="fcd_blockContent2Center1 fcd_blockContent2Center1_3">
          <div class="fcd_blockTitle">八、品牌影响</div>
          <div class="fcd_blockCommon">
            <p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;未来科学城诞生首个“全绿电”园区</p>
            <p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;北京未来科学城被认定为2023年中国产学研示范基地</p>
            <p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;未来科学城“能源谷”核心区被授予“零碳园区”标准试点</p>
            <p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;赛迪顾问发布科技城百强榜（2023）北京未来科学城排名第4</p>
            <p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;全球能源转型高层论坛已连续五年在未来科学城能源谷核心区举办，论坛的国际化、专业化、开放性进一步增强，主题更加鲜明、内容更加丰富、成果更加丰硕。同时还举办碳中和·零碳中国峰会、中-以碳中和与能源转型技术创新论坛、先进能源产业高质量发展推进会等一系列具有国际国内影响力的交流活动。</p>
          </div>
        </div>
      </div>
      <div class="fcd_blockContent2 e-flex">
        <div class="fcd_blockContent2Center1 fcd_blockContent2Center1_4">
          <div class="fcd_blockTitle">九、发展环境</div>
          <div class="fcd_blockCommon">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;紧邻京承高速，距离市中心和首都机场均一刻钟车程，地铁17号线北段已正式通车运行。国际四星级品牌酒店万怡酒店正式运营，全市最大规模山姆会员店落地未来城，集休闲、文化、体验、餐饮、娱乐等功能于一体的未来中心星际花园全面开街。抢抓北京率先建成高水平人才高地机遇，未来科学城国际人才社区加快建设，北京十一未来城学校、北师大中小学等“名校名园”建成开学，面向各类人才分配和储备的共有产权房、公租房、集租房达万余套，解决入驻企业人才后顾之忧。</div>
        </div>
      </div>
      
    </div>
  </template>
  
  <script>
    import '../../styles/parkDescription.css'
    export default {
      name: 'importantPark',
      data () {
        return {
          
        }
      },
      created() {
        
      },
      methods: {
        
      }
    }
  </script>
  
  <!-- Add "scoped" attribute to limit CSS to this component only -->
  <style scoped>
  
  </style>
  


// WEBPACK FOOTER //
// src/view/parkDescription/importantPark.vue